import Loader3D from "./Loader"

export default Loader3D
